/** Default cadence, matching the Yardi import page this was extracted from. */
export const POLL_INTERVAL_MS = 3000;

/**
 * Deliberately longer than the server's 15-minute stale-run window, so an
 * interrupted run is still observed here rather than polled forever.
 */
export const POLL_MAX_ATTEMPTS = 340;

const sleep = (ms: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Poll `fetch` until `done` accepts its result, or `maxAttempts` is reached.
 *
 * Returns the last value seen either way — a caller that ran out of attempts
 * still needs something to render, and the server marks an abandoned run failed
 * on read, so the next poll after a timeout reports the truth.
 */
export async function pollUntil<T>(
    fetch: () => Promise<T>,
    done: (value: T) => boolean,
    options: { intervalMs?: number; maxAttempts?: number } = {},
): Promise<T> {
    const { intervalMs = POLL_INTERVAL_MS, maxAttempts = POLL_MAX_ATTEMPTS } = options;
    let last = await fetch();
    for (let attempt = 1; attempt < maxAttempts; attempt++) {
        if (done(last)) return last;
        await sleep(intervalMs);
        last = await fetch();
    }
    return last;
}
